import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes/routes';
import initCfg from './common/services/config/initCfg';
import LoadingScreen from './core/ui/loadingScreen/loadingScreen';
import { IntlProvider } from '@progress/kendo-react-intl';
import initLanguage from './common/utility/initLanguage';
import initTranslations from './common/services/translations/initTranslations';
import i18n from 'i18next';

import './App.css';
import ScrollToTop from './core/ui/scrollToTop/ScrollToTop';

const App = () => {
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState('en-GB');
  const [langLoading, setLangLoading] = useState(true);

  useEffect(() => {
    initCfg()
      .then(() => {
        initTranslations().then((res) => {
          let resources = res.en.translation;
          i18n.addResourceBundle('en', 'translation', resources);
          setLangLoading(false);
        });
        initLanguage()
          .then((res) => {
            setLanguage(res);
            setLoading(false);
          })
          .catch((err) => console.log('Error: ', err));
      })
      .catch((err) => {
        console.error('Error loading config', err);
      });
  }, []);

  return (
    <>
      {loading || langLoading ? (
        <LoadingScreen />
      ) : (
        <IntlProvider locale={language}>
          <Router>
            <ScrollToTop>
              <Routes />
            </ScrollToTop>
          </Router>
        </IntlProvider>
      )}
    </>
  );
};

export default App;
